import { BaseEditViewStore} from 'core/stores';
import { FacilityOrderTemplateMissingDocumentNoteModalForm } from 'application/facility-order/forms';
import { FacilityOrderTemplateMissingDocumentService } from "application/facility-order/services";
import { action } from "mobx";

class FacilityOrderTemplateMissingDocumentNoteModalStore extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const facilityOrderTemplateMissingDocumentService = new FacilityOrderTemplateMissingDocumentService(rootStore.application.baasic.apiClient);
        const missingDocument = componentProps.modalParams.data.missingDocument;
        super(rootStore, {
            name: 'facility-order-templat-missing-document-edit-note-modal',
            Form: FacilityOrderTemplateMissingDocumentNoteModalForm,
            id: missingDocument.facilityOrderTemplateId,
            actions: () => {
                return {
                    get: () =>{
                        return missingDocument;
                    },
                    update: async (resource) => {
                        const response = await facilityOrderTemplateMissingDocumentService.update({ ...resource});
                        return response.data;
                    },
                }
            },
            FormClass: FacilityOrderTemplateMissingDocumentNoteModalForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.missingDocument = missingDocument;
        this.updateFacilityOrderTempalte = this.modalParams.data.updateFacilityOrderTempalte;
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            if(this.missingDocument.facilityOrderTemplateMissingDocumentId !== undefined){
                await this.actions.update({
                    id: this.missingDocument.facilityOrderTemplateMissingDocumentId,
                    facilityOrderTemplateId: this.missingDocument.facilityOrderTemplateId,
                    missingDocumentId: this.missingDocument.id,
                    ...resource
                });
            }

            this.missingDocument.note = this.form.$("note").value;
            if(this.updateFacilityOrderTempalte){
                this.updateFacilityOrderTempalte();
            }
            this.form.setFieldsDisabled(false);
            this.modalParams.close();
            await setTimeout(() => this.notifySuccessUpdate(this.name), 10);
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }
}

export default FacilityOrderTemplateMissingDocumentNoteModalStore;
